import { IconCalculator } from '@tabler/icons-react';

import Text from 'common/components/Text';
import NextImage from 'common/components/NextImage';
import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import Link from 'compat/Link';

import BannerWrapper, {
  BannerContent,
  BannerImage,
  BannerImageMobile,
  ButtonGroup,
  VideoWrapper,
} from './banner.style';

import bannerImg from 'common/assets/image/appCreative/bannerImg_2.png';
import bannerImgMobile from 'common/assets/image/appCreative/availableThumb.png';

const Banner = () => {

  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
          <Heading
            as="h1"
            content="From Data to Decisions: Revolutionizing Milk Quality Monitoring"
          />
          <Text content="Revolutionizing dairy management with cutting-edge technology, Linok provides real-time data analytics and insights to help farmers make smarter decisions, optimize herd health, boost production efficiency, and achieve sustainable growth" />
          <ButtonGroup>
            <Link href={'/contact-us'}>
              <Button className="primary" title="Request a demo" />
            </Link>
            <Link href={'/calculator'}>
              <Button
                className="text"
                variant="textButton"
                icon={<IconCalculator />}
                iconPosition="left"
                title="ROI Calculator"
              />
            </Link>
          </ButtonGroup>
        </BannerContent>
        <BannerImage>
          <NextImage src={bannerImg} alt="Banner" />
        </BannerImage>
        <BannerImageMobile>
          <NextImage src={bannerImgMobile} alt="Mobile Banner" />
        </BannerImageMobile>
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
